<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <h1>{{ name }}</h1>
        <div class="table-responsive">
          <table class="table-hover orderList">
            <thead>
              <tr>
                <!--<th>id</th>
                <th>objectId</th>
                <th>objectGroupId</th>
                <th>objectDescriptionId</th>-->
                <th v-for="objectSchemaField in objectSchema.fields" :key="objectSchemaField.label">
                  {{objectSchemaField.label}}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="objectDatum in filteredObjects" :key="objectDatum.id" v-on:click="objectDetails(objectDatum, objectModel, objectSchema)">
                <!--<td>{{objectDatum.id}}</td>
                <td>{{objectDatum.objectId}}</td>
                <td>{{objectDatum.objectGroupId}}</td>
                <td>{{objectDatum.objectDescriptionId}}</td>-->
                <td v-for="objectSchemaField in objectSchema.fields" :key="objectSchemaField.label">
                  {{objectDatum.data[objectSchemaField.model]}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
     <div class="row">
      <div class="col-md-12">
        <Button  label="Skapa ny" @click="createDetails()" icon="pi pi-plus" ></Button>
        <Button v-if="objectSchema.fields.filter(e => e.model === 'inActive').length > 0" :label="inActiveBtnText" @click="showInactive()" icon="pi pi-eye" ></Button><br/><br/>
      </div>
    </div>
  </div>
</template>
<script>

import ObjectDataCreate from './ObjectDataCreate'
import ObjectDataEdit from './ObjectDataEdit'
import Button from 'primevue/button'
export default {
  name: 'ObjectDataList',
  components: {
    ObjectDataCreate,
    ObjectDataEdit,
    Button
  },
  data () {
    return {
      objectGroupId: '',
      objectData: [],
      objectDataItem: '',
      objectDataModel: '',
      objectDataSchema: '',
      showFilteredObjects: false,
      inActiveBtnText: 'Visa inaktiva'
    }
  },
  props: {
    objectDataId: 0,
    objectModel: {},
    objectSchema: {},
    name: ''
  },
  watch: {
    objectDataId: function (newVal, oldVal) {
      this.fetchObjectsData(newVal)
    },
    objectModel: function (newVal, oldVal) {
      this.objectModel = newVal
    },
    objectSchema: function (newVal, oldVal) {
      this.objectSchema = newVal
    }
  },
  computed: {
    filteredObjects () {
      if (this.showFilteredObjects) {
        return this.objectData.filter(function (object) {
          if (object.data.inActive) {
            return object
          }
        })
      } else {
        return this.objectData.filter(function (object) {
          if (object.data.inActive === undefined || object.data.inActive === false) {
            return object
          }
        })
      }
    }
  },
  mounted () {
    this.fetchObjectsData(this.$props.objectDataId)
  },
  methods: {
    createDetails () {
      this.$router.push({ name: 'ObjectDataCreate', params: { model: this.objectModel, schema: this.objectSchema, groupId: this.objectGroupId, descriptionId: this.objectDataId, objectDataListId: this.$props.objectDataId } })
    },
    fetchObjectsData (objectDataId) {
      if (objectDataId === 0 || objectDataId === undefined) return
      this.$http
        .get('/api/objectdatas/objectdescriptionid/' + objectDataId)
        .then(response => {
          this.objectData = response.data
          this.objectGroupId = this.objectData[0].ObjectDescription.objectGroupId
        })
        .catch(error => console.log(error))
    },
    objectDetails (object, model, schema) {
      this.objectDataItem = object
      this.objectDataModel = model
      this.objectDataSchema = schema
      this.$router.push({ name: 'ObjectDataEdit', params: { id: object.id, schema: schema, objectDataListId: this.$props.objectDataId } })
    },
    showInactive () {
      if (this.showFilteredObjects) {
        this.showFilteredObjects = false
        this.inActiveBtnText = 'Visa inaktiva'
      } else {
        this.showFilteredObjects = true
        this.inActiveBtnText = 'Visa alla'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ObjectData/ObjectDataList.vue